<template>
  <div>
    <b-form-row>
      <b-col>
        <b-form-group label="Mot de passe">
          <b-form-input
              v-model="password"
              class="form-control"
              type="password"
              :state="validateState('password')"
              aria-describedby="input-password-feedback"
              ref="password"
          />
          <password-toggle :input="$refs['password']"/>
          <b-form-invalid-feedback id="input-password-feedback">
            <template v-if="!$v.password.required || !$v.password.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Confirmation du mot de passe">
          <b-form-input
              v-model="passwordConfirmation"
              type="password"
              :state="validateState('passwordConfirmation')"
              aria-describedby="input-password-confirm-feedback"
              ref="password-confirmation"
          />
          <password-toggle :input="$refs['password-confirmation']"/>
          <b-form-invalid-feedback id="input-password-confirm-feedback">
            <template v-if="!$v.passwordConfirmation.required || !$v.passwordConfirmation.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
            <template v-else-if="!$v.passwordConfirmation.sameAs">
              La confirmation du mot de passe doit être identique au mot de passe.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col>
        <b-form-group>
          <b-button @click="validateBeforeSubmit" variant="primary">
            <template v-if="buttonText">{{buttonText}}</template><template v-else>Réinitialiser mon mot de passe</template>
          </b-button>
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
  import PasswordToggle from '@/components/inputs/password-toggle';
  const { required, minLength, sameAs } = require('vuelidate/lib/validators');

  export default {
    name: 'ResetPasswordForm',
    components: { PasswordToggle },
    data() {
      return {
        password: '',
        passwordConfirmation: ''
      };
    },
    props: {
      buttonText: {
        type: String
      }
    },
    validations: {
      password: {
        required,
        minLength: minLength(6)
      },
      passwordConfirmation: {
        required,
        sameAs: sameAs('password'),
        minLength: minLength(6)
      }
    },
    methods: {
      validateBeforeSubmit() {
        if (this.check() === true) {
          this.$emit('valid', {
            password: this.password,
            passwordConfirmation: this.passwordConfirmation
          });
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this[field] = street;
        this.$v[field].$touch();
      },
      check() {
        this.$v.$touch();
        return !this.$v.$anyError;
      }
    }
  };
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
